export enum AutopilotArmEnum {
    None,
    Disarmed,
    Armed
}
